
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weingut/weingarten",
      function () {
        return require("private-next-pages/weingut/weingarten.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weingut/weingarten"])
      });
    }
  